export default __webpack_public_path__ + "static/media/1-Bem-Vindos.be4b2497.png";